import axios from "axios";
import { api } from "../../api";
// add blog
export const addBlog = (data) => async (dispatch) => {
  dispatch({ type: "SET_LOADER" });
  try {
    const response = await axios.post(
      `${api}/api/v2/add-blog`,
      data
    );

  
    dispatch({
      type: "DHASBOARD_BLOG_ADD_SUCCESS",
      payload: {
        successMessage: response.data.success
      },
    });
  } catch (error) {
    dispatch({
      type: "DHASBOARD_BLOG_ADD_FAIL",
      payload: error.response.data.error
    });
  }
};




// get blogs  by pagination

export const getBlogsByPagination = (page) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-blog-pagination?page=${page}`
    );
    dispatch({
      type: "PERPAGE_BLOG_GET_SUCCESS",
      payload: {
        allBlog: response.data.allBlog,
        parPage: response.data.parPage,
        blogCount: response.data.blogCount,
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};

// all blogs for slider

export const allBlogsForSlider = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-blog-for-slider`
    );
    dispatch({
      type: "SLIDER_BLOG_GET_SUCCESS",
      payload: {
        allSliderBlogs: response.data.allSliderBlogs,
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};

// recent post
export const allBlogsForRecent = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-blog-for-recent`
    );
    dispatch({
      type: "RECENT_BLOG_GET_SUCCESS",
      payload: {
        recentPost: response.data.recentPost,
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};

// get single blogs details

export const singleBlogDetails = (id) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-single-blog/${id}`
    );
    dispatch({
      type: "SINGLE_BLOG_GET_SUCCESS",
      payload: {
        singlePost: response.data.singlePost,
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};


// delete blog 

export const blogDelete = (id) => async (dispatch) => {

  try {
    const response = await axios.delete(`${api}/api/v2/delete-blog/${id}`);

    dispatch({
      type: "BLOG_DELETE_SUCCESS",
      payload:response.data.success
    });
  } catch (error) {
    console.log(error.response);
  }
};